import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "text-message-event",
  "use": "text-message-event-usage",
  "viewBox": "1 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"1 0 38 38\" id=\"text-message-event\">\n    <path fill=\"#0CED67\" d=\"M33.043 24.797c-2.324 4.648-7.073 7.585-12.27 7.587-2.13.006-4.232-.492-6.134-1.453L7.05 32.384l1.453-7.587c-.96-1.902-1.458-4.004-1.453-6.135.002-5.196 2.94-9.946 7.588-12.269 1.902-.96 4.004-1.459 6.134-1.453h.808c6.967.384 12.53 5.948 12.915 12.915v.807c.005 2.131-.493 4.233-1.453 6.135z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol